import { AppLayout } from 'layouts';
import type { UserDetail } from 'models';
import type { ReactNode } from 'react';
import { useUserQuery } from '../queries';
import { MemberLayoutSkeleton } from './member-layout-skeleton';

type P = {
  children: (member: UserDetail) => ReactNode;
  header?: (member: UserDetail) => ReactNode;
  memberId: string;
  view?: 'list' | 'member-profile';
};

const MemberLayout = ({ children, header, memberId, view }: P) => {
  const { data: member, error } = useUserQuery({
    filter: { userId: memberId },
    options: { throwOnError: false },
  });

  return (
    <AppLayout error={error}>
      {member ? (
        <>
          {header?.(member)}
          {children(member)}
        </>
      ) : (
        <MemberLayoutSkeleton view={view} />
      )}
    </AppLayout>
  );
};

export default MemberLayout;
